
    jQuery(document).ready(function($) {
        
        // Fonction universelle pour ouvrir l'Offcanvas Bootstrap 5
        function ouvrirLePanier() {
            var elPanier = document.getElementById('panierLateral');
            if (elPanier) {
                if (typeof bootstrap !== 'undefined') {
                    var bsOffcanvas = bootstrap.Offcanvas.getInstance(elPanier);
                    if (!bsOffcanvas) {
                        bsOffcanvas = new bootstrap.Offcanvas(elPanier);
                    }
                    bsOffcanvas.show();
                } else {
                    // Fallback jQuery au cas où
                    $('#panierLateral').offcanvas('show');
                }
            }
        }

        // CAS 1 : Ajout en AJAX (ex: depuis la page Boutique)
        $(document.body).on('added_to_cart', function() {
            ouvrirLePanier();
        });

        // CAS 2 : Rechargement de page (ex: depuis la Fiche Produit individuelle)
        if ( document.cookie.indexOf('ouvrir_panier_lateral=1') !== -1 ) {
            ouvrirLePanier();
            
            // On force WooCommerce à re-télécharger le contenu du panier pour être 100% sûr
            $(document.body).trigger('wc_fragment_refresh');
            
            // On nettoie le cookie pour ne pas rouvrir le panier à la page suivante
            document.cookie = "ouvrir_panier_lateral=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        }

        // CAS 3 : Code promo appliqué ou retiré sur la page de commande. WooCommerce y recalcule
        // le récapitulatif, mais pas le panier latéral : on lui fait recharger ses fragments pour
        // que la ligne de réduction et le nouveau total y apparaissent aussi.
        $(document.body).on('applied_coupon_in_checkout removed_coupon_in_checkout', function() {
            $(document.body).trigger('wc_fragment_refresh');
        });
    });